import { ElasticSearchResponse, Opportunity } from '@shared/services/elastic-search/models';
import { OpportunityDocument } from '@shared/services/elastic-search/models/opportunity-document';

export const opportunitiesSerializer = (response: ElasticSearchResponse<OpportunityDocument>): Opportunity[] =>
  response.hits.hits.map((hit) => {
    const source = hit._source;
    return {
      tid: source.tid?.[0],
      name: source.name?.[0],
      coordinates: {
        lat: source.lat?.[0],
        lng: source.lon?.[0],
      },
      isOverseas: source.isdom?.[0],
    };
  });
